<template>
	<div>
		<tab name="1"></tab>
		<div>
			<div class="auditTotalNum" v-if="dataSummary">				
				<div class="stat-item" style="grid-column: span 4;">
					<el-card shadow="never">
						<div class="title">系统退款</div>
						<div class="num clearfix">
							<span class="color-blue">{{dataSummary.refundAmount}}</span>
							<span class="color-disabled fr"
								v-if="dataSummary.refundNum">{{dataSummary.refundNum}}笔</span>
						</div>
					</el-card>
				</div>				
				<div class="stat-item" style="grid-column: span 4;">
					<el-card shadow="never">
						<div class="title">平台退款</div>
						<div class="num clearfix">
							<span class="color-blue">{{dataSummary.platformRefundAmount}}</span>
							<span class="color-disabled fr"
								v-if="dataSummary.platformRefundNum">{{dataSummary.platformRefundNum}}笔</span>
						</div>
					</el-card>
				</div>				
				<div class="stat-item" style="grid-column: span 5;">
					<el-card shadow="never">
						<div class="title">秀动多出</div>
						<div class="num clearfix">
							<span class="color-blue">{{dataSummary.showMoreAmount}}</span>
							<span class="color-disabled fr"
								v-if="dataSummary.showMoreNum">{{dataSummary.showMoreNum}}笔</span>
						</div>
					</el-card>
				</div>				
				<div class="stat-item" style="grid-column: span 5;">
					<el-card shadow="never">
						<div class="title">支付平台多出</div>
						<div class="num clearfix">
							<span class="color-blue">{{dataSummary.platformMoreAmount}}</span>
							<span class="color-disabled fr"
								v-if="dataSummary.platformMoreNum">{{dataSummary.platformMoreNum}}笔</span>
						</div>
					</el-card>
				</div>				
				<div class="stat-item" style="grid-column: span 6;">
					<el-card shadow="never">
						<div class="title">
							金额不一致  (差值=平台退款-系统退款)
						</div>
						<div class="num clearfix">
							<span class="color-blue">{{dataSummary.inconsistentAmount}}</span>
							<span class="color-disabled fr"
								v-if="dataSummary.inconsistentNum">{{dataSummary.inconsistentNum}}笔</span>
						</div>
					</el-card>
				</div>
			</div>
			<div class="page-filter-box MT30">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-date-picker v-model="params.startTime" type="date" placeholder="对账起始日期"
							value-format="yyyyMMdd" size="small" :clearable="false" :editable="false">
						</el-date-picker>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-date-picker v-model="params.endTime" type="date" placeholder="对账结束日期"
							value-format="yyyyMMdd" size="small" :clearable="false" :editable="false">
						</el-date-picker>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.type" placeholder="请选择" size="small">
							<el-option label="不限制退款渠道" value=""></el-option>
							<el-option label="仅看支付宝的-旧" :value="1"></el-option>
							<el-option label="仅看微信支付的-旧" :value="2"></el-option>
							<el-option label="仅看财付通的-旧" :value="3"></el-option>
							<el-option label="仅看抖音小程序的" :value="4"></el-option>
							<el-option label="仅看支付宝的" :value="6"></el-option>
							<el-option label="仅看微信支付的" :value="7"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.status" placeholder="请选择对账状态" size="small">
							<el-option label="不限对账状态" value=""></el-option>
							<el-option label="仅看对账完成的" :value="5"></el-option>
							<el-option label="仅看对账中的" :value="4"></el-option>
							<el-option label="仅看下载中的" :value="1"></el-option>
							<el-option label="仅看下载失败的" :value="2"></el-option>
							<el-option label="仅看下载成功的" :value="3"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
						<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
						<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div v-if="$utils.have('/finance/refund/statement/export')" class="page-btns-box">
				<el-button v-if="$utils.have('/finance/refund/statement/export')" type="primary" icon="el-icon-download"
					size="small" @click="download" :loading="downLoading">导出对账结果</el-button>
			</div>
			<div class="page-list-box">

				<el-table :data="dataList" border style="width: 100%; margin-top: 30px;" v-loading="listLoading"
					size="small" stripe>
					<el-table-column prop="time" label="对账日期" width="100"></el-table-column>
					<el-table-column prop="typeStr" label="退款渠道" width="100"></el-table-column>
					<el-table-column prop="statusStr" label="对账状态">
						<template slot-scope="scope">
							<span v-if="scope.row.statusStr != '下载失败'">
								{{scope.row.statusStr}}
							</span>
							<el-tooltip :content="scope.row.failReason" placement="top" v-else>
							    <span class="el-icon-warning-outline color-danger"> {{ scope.row.statusStr }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column label="系统退款金额 / 笔数" min-width="120">
						<template slot-scope="scope">
							{{scope.row.refundAmount}} <span v-if="scope.row.refundNum"
								class="color-success">（{{scope.row.refundNum}} 笔）</span>
						</template>
					</el-table-column>
					<el-table-column label="平台退款金额 / 笔数" min-width="120">
						<template slot-scope="scope">
							{{scope.row.platformRefundAmount}} <span v-if="scope.row.platformRefundNum"
								class="color-success">（{{scope.row.platformRefundNum}} 笔）</span>
						</template>
					</el-table-column>
					<el-table-column label="秀动多出" min-width="120">
						<template slot-scope="scope">
							<el-link icon="el-icon-thumb" type="primary"
								:href="`/finance/activity/refund/reconciliation/exception?diffType=0&startTime=${scope.row.time}&endTime=${scope.row.time}&type=${scope.row.type}`"
								v-if="scope.row.showMoreAmount || scope.row.showMoreNum">{{scope.row.showMoreAmount}}
								<span v-if="scope.row.showMoreNum" class="color-danger">（{{scope.row.showMoreNum}}
									笔）</span></el-link>

						</template>
					</el-table-column>
					<el-table-column label="支付平台多出" min-width="120">
						<template slot-scope="scope">
							<el-link icon="el-icon-thumb" type="primary"
								:href="`/finance/activity/refund/reconciliation/exception?diffType=1&startTime=${scope.row.time}&endTime=${scope.row.time}&type=${scope.row.type}`"
								v-if="scope.row.platformMoreAmount || scope.row.platformMoreNum">{{scope.row.platformMoreAmount}}
								<span v-if="scope.row.platformMoreNum"
									class="color-danger">（{{scope.row.platformMoreNum}} 笔）</span></el-link>
						</template>
					</el-table-column>
					<el-table-column label="金额不一致" min-width="120">
						<template slot-scope="scope">
							<el-link icon="el-icon-thumb" type="primary"
								:href="`/finance/activity/refund/reconciliation/exception?diffType=2&startTime=${scope.row.time}&endTime=${scope.row.time}&type=${scope.row.type}`"
								v-if="scope.row.inconsistentAmount || scope.row.inconsistentNum">{{scope.row.inconsistentAmount}}
								<span v-if="scope.row.inconsistentNum"
									class="color-danger">（{{scope.row.inconsistentNum}} 笔）</span></el-link>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="生成时间" min-width="150"></el-table-column>
				</el-table>
			</div>
			<div v-if="data" class="page-pagination-box">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
					layout="total, sizes, prev, pager, next" :total="data.totalCount || 0" />
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Tab from './components/tab';

	const defaultParams = {
		pageNo: 1,
		type: '',
		status: '',
		startTime:'20260701',
		endTime: ''
	}
	export default {
		components: {
			Tab
		},
		data() {
			return {
				data: null,
				dataList: null,
				dataSummary: null,
				timeType: 1,
				listLoading: false,
				downLoading: false,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					status: this.$route.query.status || '',
					type: this.$route.query.type || '',
				},
			}

		},
		mounted() {
			this.getDataList();
		},
		methods: {
			getDataList(keepSummary = false) {
				this.listLoading = true;
				this.$request({
						url: '/finance/refund/statementList',
						method: "POST",
						params: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							if (keepSummary) {
								if (result.summary) {
									this.dataSummary = result.summary;
								}
							} else {
								this.dataSummary = result.summary || null;
							}
							this.data = result.page || null;
							this.dataList = result.page.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.data = null;
						this.dataList = [];
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			// 切换页码
			handleCurrentChange(page) {
				this.params.pageNo = page;
				this.getDataList(true);
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList(true);
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList(false);
			},
			//重置搜索
			reset() {
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			download() {
				this.downLoading = true;
				this.$request({
						url: '/finance/refund/statement/export',
						method: "POST",
						params: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
								confirmButtonText: '立即查看',
								cancelButtonText: '稍后再看',
								type: 'success',
								center: true,
								closeOnClickModal: false
							}).then(() => {
								this.$router.push({
									path: '/workbench/downloadList'
								})
							}).catch(() => {})
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.downLoading = false;
					});
			},

		}
	}
</script>

<style lang="scss" scoped>
	.auditTotalNum {
		display: grid;
		grid-template-columns: repeat(24, 1fr);
		gap: 10px;
		margin-bottom: 20px;

		.stat-item {
			display: flex;
		}

		::v-deep .el-card {
			width: 100%;
			display: flex;
			flex-direction: column;

			.el-card__body {
				flex: 1;
				display: flex;
				flex-direction: column;
			}

			.num {
				flex: 1;
				margin-top: 15px;

				.color-blue {
					font-size: 18px;
					font-weight: bold;
				}
			}

			.title {
				font-weight: bold;
			}
		}
	}
</style>